module.exports = __webpack_public_path__ + "static/img/ykshh_2.0174a53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customer/ykshh_2.jpg
// module id = kI2x
// module chunks = 15